/**
 * CountBadge — THE unified counter badge for small numbers next to labels
 * (sidebar nav, view pills, section tabs). Story UI-U2, prototype port.
 *
 * Pure quantity indicator, NO traffic-light colors: pale neutral fill, fine
 * border, muted text. `active` inverts (light text on dark ground) for active
 * nav entries/pills. Display caps at 99+.
 *
 * [Source: brokly-design-reference/components/brokly/status-badge.tsx#CountBadge]
 * [Source: docs/stories/ui-u2-ia-navigation.md AC 3]
 */

import { cn } from '../../lib/cn';

/** Cap the rendered number so wide counts never blow up the layout. */
const DISPLAY_CAP = 99;

export function CountBadge({
  count,
  active = false,
  className,
}: {
  count: number;
  active?: boolean;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex h-5 min-w-[1.375rem] shrink-0 items-center justify-center rounded-md border px-1.5 text-xs font-medium tabular-nums',
        active
          ? 'border-transparent bg-foreground text-background'
          : 'border-border bg-background text-muted-foreground',
        className,
      )}
    >
      {count > DISPLAY_CAP ? `${DISPLAY_CAP}+` : String(count)}
    </span>
  );
}
